/**
* Indexing critical/sync scripts
* * * * * * * * * * * *
*/
var init = {};
window.aSync = {};

import '../styles/index.less';

import { $ } from './plugins/globalJquery.js';
$ = ($ == undefined ? jQuery : $);

import * as defaultResets from './plugins/defaultResets.js';
import { waitFor } from './plugins/helpers.js';

import './plugins/icons.js';
import './plugins/imageLoader.js';
import { breakpoints } from './modules/breakpoints.js';
import { loadVideo } from './modules/loadVideo.js';
import { slideDown } from './modules/slidedown.js';
//import { share } from './modules/share.js';
import { takeover } from './modules/takeover.js';
import { submenu } from './modules/submenu.js';
//import { takeoverMenu } from './modules/takeover-menu.js';
import { carousel } from './modules/carousel.js';
import { hero } from './modules/hero.js';
import { newsletters } from './modules/newsletters.js';
import { searchForm } from './modules/searchForm.js';
import { scroll } from './modules/scroll.js';

/**
* Init critical/sync scripts
* * * * * * * * * * * *
*/
init.sync = function() {
	defaultResets.init();
	breakpoints.init();
	slideDown.init();
	//share.init();
	takeover.init();
	submenu.init();
	//takeoverMenu.init();
	newsletters.init();
	init.icons();
	init.imageLoader();
	init.stickyFooter();
	searchForm.init();
	scroll.init();
}

/**
* Update breakpoints resize
* * * * * * * * * * * *
*/
breakpoints.switch.device = function(size) {
	// console.log(breakpoints.this);
	$('body').icons.init('.svg-icon');
	$('.load-image').imageLoader.resize();
};

breakpoints.resized = function() {
	$('.load-image').imageLoader.resize();
	// Update aSync functions
	if (typeof aSync.scroller != 'undefined' && aSync.scroller == true) {
		$(window).scroller.resize();
	}
};

breakpoints.switch.orientation = function() {
	// console.log('Orientation switch');
};


/**
* Init icons
* * * * * * * * * * * *
*/
init.icons = function() {
	$('body').icons({
		svg : customData.themePath + '/img/output/sprite.svg',
		offset : 2,
		ajax : true,
		testFallback : false,
		ready: function(prop) {
			//console.log(prop);
		}
	});
	$('body').icons.init('.svg-icon');
}

/**
* Init image loader
* * * * * * * * * * * *
*/
init.imageLoader = function() {
	$('.load-image').imageLoader({
		ready: function(prop) {
			// console.log(prop);
		},
		resize: function(prop) {
			// console.log(prop);
		}
	});
}

/**
* Init sticky footer
* * * * * * * * * * * *
*/
init.stickyFooter = function() {
	if ( Modernizr.mq('(min-width: 768px)') ) { // tablet portrait
		setTimeout(function(){
			var headerHeight = $( '.header' ).outerHeight(true),
				footerHeight = $( 'footer' ).outerHeight(true),
				pageHeight = $( '.page' ).outerHeight(true),
				pageNewHeight = $( window ).outerHeight(true) - headerHeight - footerHeight;
			if ( pageHeight < pageNewHeight ) {
				$( '.page' ).css( { 'min-height': pageNewHeight }); // let op: min-height!!!
			}
		},100);
	}
}

/**
* Indexing & init non-critical/aSync scripts
* * * * * * * * * * * *
*/
init.aSync = function() {
	initShare();
	initFilter();
	initCarousel();
	initHero();
	initVideo();
}

const initShare = function () {
	if ($('.js-share').length > 0) {
		if (typeof aSync.share == 'undefined') {
			import(
				'./modules/share.js'
			).then(module => {
				aSync.share = module.share;
				aSync.share.init();
			}).catch(error => 'An error occurred while loading the component');
		} else {
			aSync.share.init();
		}
	}
}

const initFilter = function() {
	if ( $( '.content--courses-archive' ).length > 0 ) {
		import(
			/* webpackChunkName: "filter" */
			'./modules/filter.js'
		).then(module => {
			aSync.filter = module.filter;
			aSync.filter.init();
		}).catch(error => 'An error occurred while loading the component');
	}
};

const initCarousel = function() {
	if ( $( '.js-carousel-slider' ).length > 0 ) {
		import(
			/* webpackChunkName: "carousel" */
			'./modules/carousel.js'
		).then(module => {
			aSync.carousel = module.carousel;
			aSync.carousel.init();
		}).catch(error => 'An error occurred while loading the component');
	}
};

const initHero = function() {
	if ( $( '.hero-container' ).length > 0 ) {
		import(
				/* webpackChunkName: "carousel" */
				'./modules/hero.js'
				).then(module => {
			aSync.hero = module.hero;
			aSync.hero.init();
		}).catch(error => 'An error occurred while loading the component');
	}
};

const initVideo = function() {
	if ( $( '.video-container' ).length > 0 ) {
		import(
			/* webpackChunkName: "loadVideo" */
			'./modules/loadVideo.js'
		).then(module => {
			aSync.loadVideo = module.loadVideo;
			aSync.loadVideo.init();
		}).catch(error => 'An error occurred while loading the component');
	}
};


/**
* Init Project
* * * * * * * * * * * *
*/
$(function() {
	init.sync();
	init.aSync();
});
